import React from "react";
import './style/logo.less';
import {generateClassName} from "jzfz-web-utils";
const logoImage = require("../../assets/images/logo.png");


interface LogoProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
	// 是否带公司名称
	withTitle?: boolean;
	// 主题 white: 白色背景
	theme?: 'white' | undefined;
}


/**
 * logo组件
 * @param props
 * @constructor
 */
const Logo = (props: LogoProps) => {
	const { className, withTitle, theme, ...resetProps } = props;


	return (
		<img
			{...resetProps}
			className={generateClassName(['common-logo-wrapper', className])}
			src={logoImage}
		/>
	)
}


export default Logo;
